const MINIMUM_ITEM_COUNT = 5;
const DEVIATION_THRESHOLD = 1.3;

/**
 * "↑ 89 % vs moyenne" when a row with enough items costs clearly more per item than the reference
 * average of the period; `null` otherwise, or when either average is unknown.
 */
const resolveDeviationChip = (
	average: number | null,
	referenceAverage: number | null,
	itemCount: number,
): string | null => {
	if (average === null || referenceAverage === null || referenceAverage <= 0) {
		return null;
	}

	if (itemCount < MINIMUM_ITEM_COUNT || average <= referenceAverage * DEVIATION_THRESHOLD) {
		return null;
	}

	return `↑ ${Math.round((average / referenceAverage - 1) * 100)} % vs moyenne`;
};

export default resolveDeviationChip;
